export const basicAuth = {
  username: "info@seobix@bumppy@goseo",
    password: "goseo@bumppy@seobix@info",
  };
  
  
  
  export const billpunchbasicauth={
    username: "abhijeet@bumppy",
    password: "password",
  
  }